
import { Component, OnInit, HostListener } from '@angular/core';
import { WindowRef } from '../../utils/window';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AuthorizationService } from '../../components/authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { RecaptchaLoaderService } from '../../utils/recaptchaLoader.service';
import { DTFHomepageService } from '../../components/dtfhomepage/dtfhomepage.service'
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { ErrorLogService } from '../../components/service/errorLogService';



declare var grecaptcha: any;
export enum CheckBoxType { 
    ENROLL_AUTOPAY, 
    ENROLL_EBILL,
    LATER, NONE 
};


@Component({
    selector: 'div.dtf-registrationConfirm',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './registrationConfirm.component.html',
    providers: [WindowRef]
})


export class RegistrationConfirmComponent implements OnInit {

    constructor(router: Router, window: WindowRef,
                public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
                public translate: TranslateService, public recaptchaLoaderService: RecaptchaLoaderService,
                public dtfhomepageService: DTFHomepageService,
                private errorLogService: ErrorLogService
                ) {
        this.router = router;
        this._window = window;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
        this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }
    check_box_type = CheckBoxType;

  currentlyChecked: CheckBoxType;
    private _window: WindowRef;
    router: Router;
    public registration: any;
    isAuthenticated = false;
    ciamLoginUrl = '';
    contextPath = '';
    currentCountry: string;
    isCanadaPortal = false;
    isReset = false;
    hasUpperCase = false;
  hasLowerCase = false;
  hasNumeric = false;
  hasMinimum = false;
  hasMaximum = false;
  userIDcheck = false;
  reentercheck = false;
  reenteremailcheck=false;
  hide = false;
  hide2 = false;
  userExist = false;
    profileExist = false;
    optionExist =false;
    autopayExist=false;
    successExist =false;
    userblock =false;
    loginLoaded = true;
    enableEbillContinue = false;
    rendered: any;
    captchaToggle = true;
    isAuth = '';
    userId = '';
    customerNumber ='';
    contractNumber ='';
    password = '';
    repassword='';
    language = '';
    openLoginModal = false;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';
    usUrl: string;
    caUrl: string;
    brandId: string;
    targetRedirect = '';
    registrationRedirect = '';
    baseUrl = '';
    logoutRedirect = '';
    classicRedirect = '';
    environment = '';
    siteKeyCaptcha = '';
    recaptchaResponse = '';
    token ='';
    EbillRequest: any = {};
    invalidToken = false;
    confirmReset = false;
    bodyLoaded=false;
    private recaptchaURL = APP_CONSTANTS.recaptchaURL;
    contractRequest: any = {};
    accountRequest: any = {};
    ebillRequest: any ={};
    emailOffers = true;
   optionForm:FormGroup;
    loginForm: FormGroup;
    userForm: FormGroup;
    emailForm: FormGroup;
    profileForm: FormGroup;
    autopayForm: FormGroup;
    ciamReCaptchaForm: FormGroup;

    formValidationClasses = {
      'mbfs-error': true,
    };

    buildForm() {
      this.loginForm = this.fb.group({
        userID: [''],
        password: ['']
      });
      this.ciamReCaptchaForm = this.fb.group({
        recaptchaResponseKey: [null, Validators.required]
    });
    this.optionForm = this.fb.group({
      eBill: [''],
     Autopay:[''],
     none: ['']
    });
    this.autopayForm = this.fb.group({
      bankRoutingNumber: [''],
     bankAccountNumber:['']
    });
    }

    selectSiteKey() {
      this.environment = (this._window.nativeWindow as any).mbfs.environment;
      if (this.environment === 'local') {
       this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
      } else if (this.environment === 'dev') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
      } else if (this.environment === 'stage') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
      } else if (this.environment === 'prod') {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      } else {
        this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
      }
    }


    ngOnInit() {
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
          this.currentCountry = val;
      });
      this.auth.cast.subscribe(data => (this.isAuthenticated = data));
      this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      if(this.isCanadaPortal === true){
        this.brandId = '3';
      }
      else{
        this.brandId = '2';
      }
     sessionStorage.setItem('brandId',this.brandId);
      this.auth.isAuthenticated(); // Checks if user is authenticated
      let element:HTMLElement = document.getElementById('auto_trigger_registrationConfirm') as HTMLElement;
      element.click();
      this.token = (this._window.nativeWindow as any).mbfs.registrationConfirm;
      this.emailverification();
    }

    onClickLogin(e: Event): void {
      this.buildForm();
      //build login form
      this.openLoginModal = true;
      }



  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.profileExist =false;
    this.reentercheck=false;
    this.isReset = false;
    this.optionExist =false;
    this.autopayExist =false;
    this.serviceErrorOccurred = false;
    this.userblock =false;
    this.enableEbillContinue = false;
    this.successExist = false;
  }
  onloadCallback() {
    this.rendered = grecaptcha.render('capcha_element', {
        'sitekey': this.siteKeyCaptcha,
        'lang': this.language
    });
}
  getResponceCapcha(captchaResponse: string) {
    // this.verifyCaptcha(captchaResponse);
    this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(captchaResponse);
    (this._window.nativeWindow as any).scrollBy(0, 1);
    this.recaptchaResponse = this.ciamReCaptchaForm.controls.recaptchaResponseKey.value;
}

  selectCheckBox(targetType: CheckBoxType) {
    // If the checkbox was already checked, clear the currentlyChecked variable
    if(this.currentlyChecked === targetType) {
      this.enableEbillContinue = false;
      this.currentlyChecked = CheckBoxType.NONE;
      return;
    }

    this.currentlyChecked = targetType;
    if(targetType !=null){
      this.enableEbillContinue = true;
    }
  }
 
submiteBilloption(e: Event){
  this.ebillRequest = {};
  if (!this.optionForm.valid) {
    this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
      this.serviceErrorDesc = data;
      this.errorLogService.logFormValidationErrors('Registration Confirm', this.optionForm, data, this.userId);
     });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 2000);  //2s
    return;
  }

  if(this.currentlyChecked === 1){
    let ebillRequest = {
    ciamId : this.userId,
    isRegistration: true,
    action : "ENROLL"
    }
    this.auth.saveEnrollOrCancelOptionToALFA(ebillRequest).subscribe(res => {
      if(res.statusMessage==='SUCCESS')
      {
        this.successExist = true;
      }
      else{
        this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
          this.serviceErrorDesc = data;
          this.errorLogService.logApiError('Registration Confirm', data, 'saveEnrollOrCancelOptionToALFA', this.userId);
         });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 7000);  //2s
      }
    });
  }
  else{
      this.successExist = true;
   }
   }

   openLogin(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }

  
  emailverification(){
    let tokenRequest = {
      validateEmailToken : this.token
    };
    this.auth.emailverification(tokenRequest).subscribe(res => {
      if(this.isCanadaPortal){
        if(res.statusMessage ==='SUCCESS'){
          this.successExist = true;
        }
        else{
          this.invalidToken = true;
          this.errorLogService.logApiError('Registration Confirm', 'Invalid email verification token', 'validateEmailToken', this.token);
        }
      }
      else{
        if(res.statusMessage ==='SUCCESS'){
          this.userId = res.userId;
          this.fetchEbillFlagForUser();
        }
        else{
          this.invalidToken = true;
          this.errorLogService.logApiError('Registration Confirm', 'Invalid email verification token', 'validateEmailToken', this.token);
        }
      }
      
    });
  }

  reregister(){
    this.translate.get('NavHeader.RegisterURL').subscribe((data: any) => {
      let redirect= this.baseUrl + data;
      window.location.href = redirect;
    });
  } 

  fetchEbillFlagForUser() {
    this.EbillRequest = {};
    this.EbillRequest = {
      ciamId: this.userId,
      isRegistration:"true"
    };
    this.auth.fetchEbillFlagForUser(this.EbillRequest).subscribe(res => {

      // if (res.enrollFlagFromDB === 'TERMINATE') {
      //   this.optionExist = true;
      // }
      // else {
        this.successExist = true;
     // }
});
}
}